import { fetchActionFactory } from '../../../shared/store/fetchFactory';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import { fetchingError } from '../../../shared/store/actions';

import {
  CALCULATE_SCENARIO,
  CALCULATE_SCENARIO_FAILURE,
  CALCULATE_SCENARIO_SUCCESS,
  FETCH_SCENARIOS,
  SET_SELECTED_COMPARE_SCENARIO,
  SET_SELECTED_SCENARIO_CURRENCY,
  SET_SELECTED_SCENARIO_EDIT_CY,
  SET_SELECTED_SCENARIO_VIEW,

  FETCH_SCENARIO_REPORT_FIELDS,

  UPLOAD_TAGGED_DATA_FILE,
  UPLOAD_TAGGED_DATA_FILE_FAILURE,
  UPLOAD_TAGGED_DATA_FILE_SUCCESS,
  CLEAR_UPLOAD_TAGGED_DATA_ERRORS,

  FETCH_ALLOWED_PERIODS_FOR_SCENARIOS,
} from './types';

import {
  calculateScenario as calculateScenarioApi,
  fetchScenarioReportFields as fetchScenarioReportFieldsApi,
  fetchScenarios as fetchScenariosApi,
  uploadTaggedDataFile as uploadTaggedDataFileApi,
  fetchAllowedPeriodsForScenarios as fetchAllowedPeriodsForScenariosApi,
} from '../api';

export const fetchScenarios = fetchActionFactory(
  FETCH_SCENARIOS,
  fetchScenariosApi,
  { field: 'scenarios' }
);

export const fetchAllowedPeriods = fetchActionFactory(
  FETCH_ALLOWED_PERIODS_FOR_SCENARIOS,
  fetchAllowedPeriodsForScenariosApi,
  { field: 'scenarioAllowedPeriods' }
);

export const setSelectedCompareScenario = scenario => ({
  type: SET_SELECTED_COMPARE_SCENARIO,
  scenario,
});

export const setSelectedView = view => ({
  type: SET_SELECTED_SCENARIO_VIEW,
  view,
});

export const setSelectedEditCy = editCy => ({
  type: SET_SELECTED_SCENARIO_EDIT_CY,
  editCy,
});

export const setSelectedCurrency = currency => ({
  type: SET_SELECTED_SCENARIO_CURRENCY,
  currency,
});

export const clearUploadTaggedDataErrors = () => ({
  type: CLEAR_UPLOAD_TAGGED_DATA_ERRORS,
});

export const calculateScenario = (scenarioId, { onSuccessCallback } = {}) => async dispatch => {
  try {
    dispatch({ type: CALCULATE_SCENARIO });

    await calculateScenarioApi(scenarioId);

    dispatch({ type: CALCULATE_SCENARIO_SUCCESS });
    if (onSuccessCallback) {
      onSuccessCallback();
    }
    dispatch(successNotification('Scenario calculated successfully'));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({ type: CALCULATE_SCENARIO_FAILURE });
    }
    throw error;
  }
};


export const fetchScenarioReportFields = fetchActionFactory(
  FETCH_SCENARIO_REPORT_FIELDS,
  fetchScenarioReportFieldsApi,
  {
    field: 'reportFields',
  }
);


export const uploadTaggedDataFile = ({ scenarioId, file }, { onSuccessCallback } = {}) => async dispatch => {
  dispatch({ type: UPLOAD_TAGGED_DATA_FILE });

  const formData = new FormData();
  formData.append('file', file);

  try {
    await uploadTaggedDataFileApi(scenarioId, formData);

    if (onSuccessCallback) {
      onSuccessCallback();
    }
    dispatch({
      type: UPLOAD_TAGGED_DATA_FILE_SUCCESS,
    });
    dispatch(successNotification('Scenario tagged data imported successfully'));
  } catch (error) {
    dispatch({ type: UPLOAD_TAGGED_DATA_FILE_FAILURE, errors: error.isBadRequestError && error.errors });

    if (error.isFetchingError || error.isBadRequestError) {
      dispatch(fetchingError(error.message));
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};
